import LotteryNumlotStatsContainer from "../../components/lottery/containers/LotteryNumlotStatsContainer";
import LotteryNumlotStatsTemplate from "../../components/lottery/templates/LotteryNumlotStatsTemplate";
import LotteryLocalNav from "../../components/lottery/LotteryLocalNav";

function Loto6Stats() {
  return (
    <>
      <LotteryLocalNav placement="mainHeader" lotteryKey="lt6" />
      <section className="min-h-screen">
        <LotteryNumlotStatsContainer lotteryKey="lt6" Template={LotteryNumlotStatsTemplate} />
      </section>
      <LotteryLocalNav placement="mainFooter" lotteryKey="lt6" />
    </>
  );
}
export default Loto6Stats;